export const mitigationStatusColors = {
  Proposed: "border-yellow-400 bg-yellow-50",
  Implemented: "border-green-400 bg-green-50",
  Transferred: "border-blue-400 bg-blue-50",
  Rejected: "border-red-400 bg-red-50",
};
